import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-change-iban-page',
  templateUrl: './change-iban-page.component.html',
  styleUrls: ['./change-iban-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChangeIbanPageComponent {

}
